import script from "./THeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./THeader.vue?vue&type=script&lang=ts&setup=true"

import "./THeader.vue?vue&type=style&index=0&id=0be6ee13&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be6ee13"]])

export default __exports__